import { formatParticipantDay } from './adapters/campaignParticipantsAdapter'

export const formatPauseRemindersToast = (result = {}, { name, pausedUntil } = {}) => {
  const updated = result.updated ?? 0
  const until = formatParticipantDay(pausedUntil)
  if (updated === 1 && name && until) {
    return `Reminders for ${name} paused until ${until}.`
  }
  if (updated === 1 && name) {
    return `Reminders for ${name} paused.`
  }
  if (updated === 1) {
    return 'Reminders paused for 1 participant.'
  }
  if (updated > 1) {
    return `Reminders paused for ${updated} participants.`
  }
  return 'No reminders were paused.'
}

export const formatResumeRemindersToast = (result = {}, { name } = {}) => {
  const updated = result.updated ?? 0
  if (updated === 1 && name) {
    return `Reminders resumed for ${name}.`
  }
  if (updated === 1) {
    return 'Reminders resumed for 1 participant.'
  }
  if (updated > 1) {
    return `Reminders resumed for ${updated} participants.`
  }
  return 'No paused reminders to resume.'
}
